

export const PDD_MOVE_USER_INFO_KEY = 'xf_fenxiao_user_info_by_pdd_move'

// 获取晓风上货的当前的店铺信息
export function Service_GetPddMoveInfo() {
  const userInfo = localStorage.getItem(PDD_MOVE_USER_INFO_KEY) && JSON.parse(localStorage.getItem(PDD_MOVE_USER_INFO_KEY))
  return userInfo || {}
}

// 删除晓风上货的当前的店铺信息
export function Service_DeletePddMoveInfo() {
  localStorage.removeItem(PDD_MOVE_USER_INFO_KEY)
}

// 设置晓风上货的当前的店铺信息
export function Service_SetPddMoveInfo(data) {
  localStorage.setItem(PDD_MOVE_USER_INFO_KEY, JSON.stringify(data))
}

export function Service_GetPddMoveToken() {
  var userInfo = localStorage.getItem(PDD_MOVE_USER_INFO_KEY) &&  JSON.parse(localStorage.getItem(PDD_MOVE_USER_INFO_KEY))
  return userInfo?.Token || ''
}

export function Service_GetRelationId() {
  var mallInfo = Service_GetPddMoveInfo()
  return mallInfo.Id || ''
}